<template>
  <div>
    <b-modal
      id="modal-snippet"
      ref="modal-snippet"
      title="Save Notes"
      centered
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      hide-footer
    >
      <div v-if="!snippetDeleted">
        <b-alert v-model="description_check" variant="danger" dismissible>
          Notes cannot be empty.
        </b-alert>
        <b-form-textarea
          v-model="snippetDescription"
          :disabled="snippetCreated"
          placeholder="Add notes..."
          rows="3"
          max-rows="6"
        ></b-form-textarea>
        <div class="modal-footer">
          <b-button
            v-show="!snippetCreated"
            class="mt-2"
            variant="secondary"
            style="width: auto"
            @click="cancelCreate"
            >Cancel
          </b-button>
          <b-button
            v-show="!snippetCreated"
            class="mt-2"
            variant="primary"
            style="width: auto"
            @click="confirmModal"
            >Save Result
          </b-button>
        </div>
      </div>
      <div v-if="snippetCreated" id="success">
        <b-alert variant="success" show>Saved result.</b-alert>
        <div class="text-right">
          <b-button class="mt-2" variant="primary" @click="confirmCreate"
            >Close
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'SnippetModal',
  data() {
    return {
      snippetCreated: false,
      snippetDeleted: false,
      snippetDescription: this.snippet ? this.snippet.description : '',
      description_check: false,
    };
  },
  computed: {
    ...mapGetters([
      'modalSnippet',
      'hit',
      'hitIdx',
      'pageNum',
      'filters',
      'query',
      'mode',
      'projects',
      'project',
      'snippet',
      'editSnippet',
      'activeSnippetIds',
    ]),
  },
  watch: {
    modalSnippet(status) {
      if (status) {
        this.snippetDescription = this.snippet.description;
        this.$refs['modal-snippet'].show();
      } else {
        this.$refs['modal-snippet'].hide();
      }
    },
  },
  methods: {
    resetSnippet() {
      this.snippetDescription = '';
      this.snippet.description = '';
      this.snippetDeleted = false;
      this.description_check = false;
    },
    deleteSnippet(snippet_id) {
      this.$store.dispatch('DESTROY_SNIPPET', snippet_id);
      this.snippetDeleted = true;
    },
    confirmCreate() {
      this.$store.commit('SHOW_MODAL_SNIPPET', { status: false });
      this.$store.commit('RESET_SNIPPET');
      this.snippetCreated = false;
      this.resetSnippet();
    },
    cancelCreate() {
      this.$store.commit('SHOW_MODAL_SNIPPET', {
        status: false,
        edit: false,
      });
      this.$store.commit('RESET_SNIPPET');
      this.resetSnippet();
    },
    confirmModal() {
      if (!this.snippetDescription) {
        this.description_check = true;
        return;
      }
      this.description_check = false;
      const payload = {
        hit: this.hit,
        hitIdx: this.hitIdx,
        pageNum: this.pageNum,
        description: this.snippetDescription,
        query: this.query,
        project: this.project.id,
        filters: this.filters,
        mode: this.mode,
        actionDateStart: this.actionDateStart,
        actionDateEnd: this.actionDateEnd,
      };
      if (this.editSnippet) {
        payload.id = this.snippet.id;
        this.$store.dispatch('UPDATE_SNIPPET', payload);
      } else {
        this.$store.dispatch('SAVE_SNIPPET', payload);
      }
      this.snippetCreated = true;
    },
  },
};
</script>
